import { Box, Flex } from "@chakra-ui/react";
import { useInvestorDisplayName } from "@equidefi/portals/hooks/useInvestorDisplayName";

import { HeaderAvatar, HeaderBreadcrumb, HeaderCard, HeaderTitle } from "@/components/nav/HeaderCard";
import { TInvestmentDTO } from "@/types/dto";

interface InvestmentHeaderCardProps {
  investment: TInvestmentDTO;
}

export function InvestmentHeaderCard({ investment }: InvestmentHeaderCardProps): React.JSX.Element {
  const { offering, issuer, vault, investment_vault_records } = investment || {};
  const { name: issuerName, photo_url: issuerPhotoUrl } = issuer || {};

  const displayName = useInvestorDisplayName(vault, investment_vault_records);

  return (
    <HeaderCard>
      <Flex align="center" gap={3}>
        <HeaderAvatar url={issuerPhotoUrl} alt={`${issuerName} Logo`} />
        <Box>
          <HeaderBreadcrumb
            crumbs={{
              [issuerName]: `/issuers/${offering?.issuer_id}`,
              [offering?.name]: `/offerings/${offering?.id}/investments`,
            }}
          />
          <HeaderTitle mb={0}>Investment by {displayName}</HeaderTitle>
        </Box>
      </Flex>
    </HeaderCard>
  );
}
